import { Lightning as lng } from '@lightningjs/sdk';
import { InputField } from '@lightningjs/ui';
import { AtvKeyboardService } from './AtvKeyboardService';
import { Theme } from '../../config/theme';

export class AtvKeyboardInput extends lng.Component {
  static _template() {
    return {
      Background: {
        rect: true,
        color: 0xffffffff,
        w: w => w,
        h: h => h,
        visible: true,
      },
      Input: {
        x: 8,
        y: 0,
        type: InputField,
        labelPositionStatic: false,
        autoHideCursor: true,
        inputText: {
          textColor: 0xff000000,
          ...Theme.Fonts.Default,
        },
        cursor: {
          color: 0xff000000,
        },
      },
      Line: {
        y: 56,
        w: w => w,
        h: 4,
        rect: true,
        color: Theme.Colors.Primary,
        visible: false,
      },
      w: w => w,
      h: h => h,
      clipping: true,
      cursorOnFocus: true,
    };
  }

  _construct() {
    this._emailMode = false;
    this._numpadMode = false;
    this.focusInputColor = 0xffffffff;
    this.unfocusInputColor = 0xffffffff;
    this._textRightMargin = 50;
  }

  _active() {
    this.tag('Line').color = this.hasFocus() ? this.focusInputColor : this.unfocusInputColor;
    this.tag('Background').color = this.hasFocus() ? this.focusInputColor : this.unfocusInputColor;
    if (!this.hasFocus()) this.tag('Input').autoHideCursor = true; //hack needed to fix InputField TxLoad timing with other events
    this.tag('Input').toggleCursor(false);
    this.tag('Input').cursor = { x: 3, h: 52 };
    this.tag('Input').maxLabelWidth = this.w - this._textRightMargin;
  }

  get inputField() {
    return this.tag('Input');
  }

  _getFocused() {
    return undefined;
    // might be tempted to do something like this, but the focus needs to be set on the kb by the parent of the kb
    // so the parent with which init() was called on the service
    // return this.keyboardOpen
    //   ? FullKeyboardService.instance.keyboard
    //   : undefined;
  }

  _focus() {
    this.tag('Line').color = this.focusInputColor;
    this.tag('Background').color = this.focusInputColor;
    this.tag('Input').autoHideCursor = false; //hack needed to fix InputField TxLoad timing with other events
    if (this.cursorOnFocus) this.tag('Input').toggleCursor(true);
  }

  _unfocus() {
    if (this.cursorOnFocus && AtvKeyboardService.instance && !AtvKeyboardService.instance.isOpen) {
      this.tag('Line').color = this.unfocusInputColor;
      this.tag('Background').color = this.unfocusInputColor;
      this.tag('Input').toggleCursor(false);
    }
  }

  reset() {
    this.tag('Input').autoHideCursor = true; //hack needed to fix InputField TxLoad timing with other events
    this.tag('Line').color = this.unfocusInputColor;
    this.tag('Background').color = this.unfocusInputColor;
    this.tag('Input').toggleCursor(false);
  }

  set inputColors({ focus, unfocus }) {
    this.focusInputColor = focus;
    this.unfocusInputColor = unfocus;
    this.tag('Line').color = this.hasFocus() ? this.focusInputColor : this.unfocusInputColor;
    this.tag('Background').color = this.hasFocus() ? this.focusInputColor : this.unfocusInputColor;
  }

  set showUnderline(val) {
    this.tag('Line').visible = val;
    this.tag('Background').visible = !val;
  }

  set textColor(color) {
    this.tag('Input').inputText = { textColor: color };
  }

  set cursorColor(color) {
    this.tag('Input').cursor.color = color;
  }

  get input() {
    return this.tag('Input').input;
  }

  set passwordMode(val) {
    this.tag('Input').passwordMode = val;
    if (this.input) {
      this.tag('Input').autoHideCursor = true; //hack needed to fix InputField TxLoad timing with other events
      this.tag('Input').onInputChanged({ input: this.input });
      this.tag('Input').toggleCursor(false);
    }
  }

  set emailMode(val) {
    this._emailMode = val;
  }

  set numpadMode(val) {
    this._numpadMode = val;
  }

  set textRightMargin(margin) {
    this._textRightMargin = margin;
  }

  onInputFinished() {
    this.signal('onFinished', this);
    this._unfocus();
  }

  onInputChanged(arg) {
    this.signal('onChanged', this, arg);
  }

  _handleEnter() {
    if (AtvKeyboardService.instance && !AtvKeyboardService.instance.isOpen) {
      AtvKeyboardService.instance.emailMode = this._emailMode;
      AtvKeyboardService.instance.numpadMode = this._numpadMode;
      AtvKeyboardService.instance.connect(
        this.tag('Input'),
        this.onInputFinished.bind(this),
        this.onInputChanged.bind(this)
      );
    }
  }

  clear() {
    const input = this.tag('Input');
    if (!input) return;
    input._input = '';
    input._update();
    if (input.tag('Cursor')) input.tag('Cursor').x = 0;
  }
}
